// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"label__visuallyhidden--qa7f2","focusable":"label__focusable--h8dph","with-colon":"label__with-colon--HInUS","withColon":"label__with-colon--HInUS"};